/**
 * Check if argument is error.
 * @param `data` - Unknown data
 * @returns `Guard` - `data is Error`
 */
export function isError(data) {
    return data instanceof Error;
}
export function onFailThrow(data) {
    return (...args) => {
        const result = data(...args);
        if (result instanceof Promise) {
            return result.then((q) => {
                if (isError(q)) {
                    // tslint:disable-next-line: no-throw
                    throw q;
                }
                return q;
            });
        }
        if (isError(result)) {
            // tslint:disable-next-line: no-throw
            throw result;
        }
        return result;
    };
}
// tslint:disable-next-line: promise-function-async
export function canFail(fn) {
    try {
        const r = fn();
        if (r instanceof Promise) {
            return r.catch((err) => {
                if (isError(err)) {
                    return err;
                }
                return new UnknownError(err);
            });
        }
        return r;
    }
    catch (err) {
        if (isError(err)) {
            return err;
        }
        return new UnknownError(err);
    }
}
export class RequestError extends Error {
    constructor(status, message) {
        super(`${message}`);
        this.status = status;
        this.message = message;
        this.name = 'RequestError';
    }
}
export class CriticalBugError extends Error {
    constructor(message, data) {
        super(`${message}`);
        this.data = data;
        this.name = 'CriticalBugError';
    }
}
export class UnknownError extends Error {
    constructor(data) {
        super(JSON.stringify(data));
        this.data = data;
        this.name = 'UnknownError';
    }
}
export class MultiError extends Error {
    constructor(errors) {
        super(errors.map((e) => `${e.name}: ${e.message}`).join('\n'));
        this.errors = errors;
        this.name = 'MultiError';
    }
}
export class ValidationError extends Error {
    constructor(message, data) {
        super(`${data.method}. ${message}`);
        this.message = message;
        this.name = 'ValidationError';
    }
}
/**
 * Ensures that err is Error instance
 */
export function ensureError(err) {
    if (isError(err)) {
        return err;
    }
    return new UnknownError(err);
}
